import styled from "styled-components";

export const OTPTimmer = styled.div`
   padding: 10px 0px 10px 0px;
    > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
   button {
    background: none !important;
    color: black !important;
   }
   span {
    font-size: 12px;
    font-family: "latomedium";

   }
`;